export default __webpack_public_path__ + "assets/fullscreen_disable.d7f5f6bf.svg";